import type { RequestHandler } from "msw";

class MockHandlerRegistry {
  private handlers: RequestHandler[] = [];

  register(handlers: RequestHandler[]): void {
    this.handlers.push(...handlers);
  }

  getHandlers(): RequestHandler[] {
    return this.handlers;
  }

  clear(): void {
    this.handlers = [];
  }
}

export const mockHandlerRegistry = new MockHandlerRegistry();
